export const POLL_SECONDS = 3;

export const PAGE_SIZE = 200;
